var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.inputStyle)},[_c('input',{ref:"input",class:['form-control', _vm.size ? ("form-control-" + _vm.size) : ''],attrs:{"type":"text","placeholder":_vm.placeholder,"disabled":_vm.disabled}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c37360e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/DatePicker.vue
// module id = 816
// module chunks = 0